var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEngagrWhHoz02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1797 821.5",
    style: {
      enableBackground: "new 0 0 1797 821.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000108275639419629111270000009303925956627640252_);}\n\t.st2{fill:url(#SVGID_00000112619977034431374270000001256317325305799324_);}\n\t.st3{fill:url(#SVGID_00000085239874217177788180000004907991837231580825_);}\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.5566,
    y1: -67.3952,
    x2: 720.7176,
    y2: 25.0736,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -311.7558 285.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.7,528c-24.8-15.4-57.2-7.7-72.4,17.1l-83.7,135.4c-15.2,24.8-7.7,57.2,17.1,72.4 c24.8,15.4,57.2,7.7,72.4-17.1l83.7-135.4C324.2,575.6,316.5,543.2,291.7,528z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162311528863433809350000013655950770658404749_",
    gradientUnits: "userSpaceOnUse",
    x1: 720.3858,
    y1: 23.0304,
    x2: 846.8363,
    y2: 96.0368,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -311.7558 285.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162311528863433809350000013655950770658404749_)"
    },
    d: "M435.3,567.5 c-24.8-15.4-57.2-7.7-72.4,17.1L320.1,654c-15.2,24.8-7.7,57.2,17.1,72.4s57.2,7.7,72.4-17.1l42.8-69.3 C467.8,615.3,460.1,582.8,435.3,567.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093162049802977619990000008477946334519042702_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.3901,
    y1: 22.9653,
    x2: 556.8591,
    y2: 95.9821,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -311.7558 285.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093162049802977619990000008477946334519042702_)"
    },
    d: "M188.6,415.2 c-24.8-15.4-57.2-7.7-72.4,17.1l-42.8,69.3C58,526.4,65.7,558.8,90.5,574c24.8,15.4,57.2,7.7,72.4-17.1l42.8-69.3 C221,462.8,213.3,430.4,188.6,415.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099641064497521154320000007997780367363461565_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.7187,
    y1: 291.2873,
    x2: 825.5988,
    y2: 505.415,
    gradientTransform: "matrix(0.8509 0.5254 0.5254 -0.8509 -311.7558 285.8549)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC0D6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE4725"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099641064497521154320000007997780367363461565_)"
    },
    d: "M329.7,465.5 c100.5,62,232.8,30.8,294.8-69.7S655.3,163,554.8,101S322,70.1,260,170.6S229.2,403.4,329.7,465.5z M499.5,190.4 c51,31.5,67.1,98.8,35.6,149.8s-98.8,67.1-149.8,35.6S318.2,277,349.7,226S448.5,158.8,499.5,190.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M768.2,461.6c0-41.6,26.7-69.4,67-69.4c40.2,0,67,28.4,67,71.5l-2.1,2.1h-110c1,27.8,19.1,46.5,45.4,46.5 c19.8,0,36.8-11.8,42.7-29.5h21.5c-8.7,28.8-34.3,48.2-64.2,48.2C794.9,531,768.2,503.2,768.2,461.6z M879.5,447 c-5.2-23.2-21.2-36.4-44.4-36.4s-39.2,13.2-44.4,36.4H879.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M928.1,395h21.5v17c9.4-11.8,26-19.8,41.6-19.8c33.3,0,55.5,21.5,55.5,53.4v82.9h-21.5v-79.1 c0-22.9-15.3-38.5-37.8-38.5s-37.8,15.6-37.8,38.5v79.1h-21.5V395z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1068.6,531h21.9c5.6,19.8,20.8,30.9,42,30.9c28.4,0,44.4-17.3,44.4-48.2v-9.4c-9.7,14.2-28.1,23.6-46.1,23.6 c-38.2,0-63.8-27.4-63.8-68c0-40.9,25.7-68,63.8-68c18,0,36.4,9.7,46.1,23.9v-21.5h21.5v119c0,42.7-23.9,66.6-65.6,66.6 C1098.8,580.6,1075.9,562.9,1068.6,531z M1176.8,460.2c0-29.5-17.7-49.3-44.1-49.3c-26.7,0-44.8,19.8-44.8,49.3s18,49.3,44.8,49.3 C1159.1,509.8,1176.8,490,1176.8,460.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1223.7,461.6c0-41.6,26-69.4,65.2-69.4c18,0,37.1,10.1,47.5,25v-22.6h21.5v133.6h-21.5v-22.6 c-10.4,14.9-29.5,25-47.5,25C1250,531,1223.7,503.2,1223.7,461.6z M1336.4,461.6c0-30.5-18-50.6-45.4-50.6 c-27.4,0-45.8,20.1-45.8,50.6s18.4,50.6,45.8,50.6C1318.4,512.2,1336.4,492.1,1336.4,461.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1380.1,531h21.9c5.6,19.8,20.8,30.9,42,30.9c28.4,0,44.4-17.3,44.4-48.2v-9.4c-9.7,14.2-28.1,23.6-46.1,23.6 c-38.2,0-63.8-27.4-63.8-68c0-40.9,25.7-68,63.8-68c18,0,36.4,9.7,46.1,23.9v-21.5h21.5v119c0,42.7-23.6,66.6-65.6,66.6 C1410.2,580.6,1387.1,562.9,1380.1,531z M1488,460.2c0-29.5-17.7-49.3-44.1-49.3c-26.7,0-44.8,19.8-44.8,49.3s18,49.3,44.8,49.3 C1470.7,509.8,1488,490,1488,460.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1541.4,395h21.5v18.4c11.1-14.6,23.2-21.2,38.2-21.2c4.2,0,8.3,1,11.1,2.8v16h-9c-23.9,0-39.9,15.6-39.9,39.5 v78.1h-21.5V395H1541.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagrWhHoz02);
export default __webpack_public_path__ + "static/media/engagr-wh-hoz-02.5267fff5c5e02c78dac4c79266543654.svg";
export { ForwardRef as ReactComponent };